export default "__VITE_ASSET__cec45433__"